export class SecurityGroupRule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "protocol",
            "baseName": "protocol",
            "type": "SecurityGroupRuleProtocol",
            "format": ""
        },
        {
            "name": "fromPort",
            "baseName": "fromPort",
            "type": "number",
            "format": ""
        },
        {
            "name": "toPort",
            "baseName": "toPort",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityGroupRule.attributeTypeMap;
    }
    constructor() {
    }
}
